export const initialState = {
  patientAssistiveTechnologies: [],
  assistiveTechnologies: []
};
